import { inject } from '@angular/core';
import { GvTaTrackerAssignmentApiService } from '@shared/services';
import { PopoverHandlerConfig, PopoverConfig } from '../generic-popover.interfaces';
import { defaultCancelAction, defaultConfirmAction } from './default-actions';
import { reassignGvTaTrackerFormConfig } from '@shared/components/edit-create-form';

export const reassignGvTaTrackerPopoverConfig = (
    onSuccess: () => void,
    onCancel: () => void
): PopoverConfig => {
    const trackerAssignmentApiService = inject(GvTaTrackerAssignmentApiService);

    return {
        width: '600px',
        title: 'Chuyển đổi Tracker cho GV/TA',
        dismissable: true,
        styleClass: 'p-fluid',
        formConfig: reassignGvTaTrackerFormConfig(),
        actions: [defaultCancelAction, defaultConfirmAction],
        handlerConfig: {
            service: trackerAssignmentApiService,
            method: 'reassignGvTaToTracker',
            entityLabel: 'chuyển đổi tracker',
            commonDataTransform: (formValue: any) => ({
                assignmentId: formValue.assignmentId,
                newTrackerEmployeePositionId: formValue.newTrackerEmployeePositionId,
                fromDate: formValue.fromDate
            }),
            initialDataTransform: (rawData: any) => ({
                assignmentId: rawData.assignmentId || rawData.id,
                gvTaEmployeePosition: rawData.gvTaEmployeePosition,
                trackerEmployeePosition: rawData.trackerEmployeePosition,
                newTrackerEmployeePositionId: rawData.newTrackerEmployeePositionId || null,
                fromDate: rawData.fromDate || new Date(new Date().setHours(0, 0, 0, 0))
            }),
            onSuccess,
            onCancel
        } as PopoverHandlerConfig
    };
};

